import React from "react";
import {
  Button,
  SimpleGrid,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger
} from "@chakra-ui/react";
import { RiPencilFill } from "react-icons/ri";
import { DRAWING_TOOL_COLORS, ToolsConfig } from "duck";

interface ColorPickerProps {
  config: ToolsConfig;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ config }) => {
  const { color, updateColor, updateMode } = config;

  return (
    <Popover variant="picker">
      <PopoverTrigger>
        <IconButton
          colorScheme="minor"
          bg={color.name}
          aria-label="Draw"
          icon={<RiPencilFill />}
          _hover={{ background: color.name }}
        />
      </PopoverTrigger>
      <PopoverContent width="264px">
        <PopoverArrow />
        <PopoverBody>
          <SimpleGrid columns={5} spacing={2}>
            {DRAWING_TOOL_COLORS.map(c => (
              <Button
                key={c.name}
                bg={c.name}
                h={10}
                w={10}
                p={0}
                minW="unset"
                _hover={{ background: c.name }}
                onClick={() => {
                  updateColor(c);
                  updateMode("pen");
                }}
              />
            ))}
          </SimpleGrid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPicker;
